import { FC, useEffect } from 'react';
import { useAuthContext } from '@/context/AuthContext.tsx';
import { Outlet } from 'react-router-dom';
import Middleware from '@/router/middleware/index.tsx';
import { passToRouteSearchParams } from '@/utils/passToRouteSearchParams.ts';
import SearchParams from '@/_constants/SearchParams.ts';
import OnboardingStep from '@/_constants/OnboardingStep.ts';

const IsOnboardingCompleted: FC = () => {
  const { isLoading, user } = useAuthContext();

  const redirectUrl = passToRouteSearchParams(import.meta.env.VITE_ONBOARDING_URL, {
    [SearchParams.RETURN_URL]: encodeURI(window.location.href),
  });

  useEffect(() => {
    if (!isLoading && user?.onboarding_step !== OnboardingStep.FINISHED) {
      window.location.href = redirectUrl;
    }
  }, [isLoading, redirectUrl, user]);

  return (
    <Middleware isLoading={isLoading || user?.onboarding_step !== OnboardingStep.FINISHED}>
      {user?.onboarding_step === OnboardingStep.FINISHED ? <Outlet /> : null}
    </Middleware>
  );
};

export default IsOnboardingCompleted;
